import React, { useEffect, useState, useRef } from 'react';
import useToolbarSetter from '../../hooks/Common/useToolbarSetter';
import picture from './dummy/traffic_camera_pic.jpg';
import useModals from '../../hooks/Common/useModals';
import { CommonModal } from '../Common/CommonModal';
import CanvasComponent from '../FaceRecognition/CanvasComponent';
import AlertCanvasComponent from '../Alerts/AlertCanvasComponent';
import { useParams } from 'react-router-dom';
import { LeafMap } from '../Map/LeafMap';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import getLatestLPR from '../../web_api/methods/traffic/getLatestLPR';
import { lprDetectionInList, lprDetectionList } from '../../web_api/models';
import getAzureFile from '../../web_api/methods/files/getAzureFile';
import { DEMO_ACCOUNTS } from '../../web_api/constants';

const TrafficSearch = () => {
  const { setToolbar, setBackButton } = useToolbarSetter();
  useEffect(() => {
    setToolbar('traffic-search', `Traffic Search - ${selectedLicencePlate}`);
    setBackButton(true);

    return () => {
      setBackButton(false);
    };
  });

  const params = useParams();
  const userName = useSelector((state: RootState) => state.user.user_name);
  const dateFilter = useSelector((state: RootState) => state.dateFilter);

  const selectedLicencePlate = String(params.id);
  const [selectedItem, setSelectedItem] = useState<lprDetectionInList>();
  const [results, setResults] = useState<lprDetectionList>([]);
  const [lines, setLines] = useState<any>([]);
  const [progress, setProgress] = useState(0);
  const [timeoutIds, setTimeoutIds] = useState<NodeJS.Timeout>();
  const [highlightedMarkerId, setHighlightedMarkerId] = useState<number>(-1);
  // Player control states
  const [isPlaying, setIsPlaying] = useState(false);
  const currentLineIndexRef = useRef(0); // ref to avoid stale closure in timeouts

  const { show, toggleModal } = useModals([false]); // 0 for changesModal, 1 for confirmDeleteModal

  const computeUrlAlert = async (alert: lprDetectionInList) => {
    const res = await getAzureFile(alert.filename);
    return res;
  };

  const loadItems = async () => {
    if (DEMO_ACCOUNTS.includes(userName)) {
      return;
    }

    let res = await getLatestLPR({ from_param: new Date(dateFilter.from), to_param: new Date(dateFilter.to), search_term: selectedLicencePlate });
    res = await Promise.all(
      res.map(async (alert) => {
        alert.filename = await computeUrlAlert(alert);
        return alert;
      })
    );
    // reverse results to have oldest first
    res = res.reverse();
    setResults(res);
    return res;
  };

  // Intentionally run once on mount; dependencies (loadItems, results) excluded to avoid replaying animation setup
  useEffect(() => {
    setLines([]);
    loadItems().then((res) => {
      console.log('res', res);
      console.log('results', results);
      if (!res) return;
      for (let i = 0; i < res.length; i++) {
        if (i === res.length - 1) break;
        const line = {
          id: i,
          positionStart: {
            lat: res[i].camera_lat,
            long: res[i].camera_long,
          },
          positionEnd: {
            lat: res[i + 1].camera_lat,
            long: res[i + 1].camera_long,
          },
          color: 'yellow',
        };
        console.log('adding line', line);
        setLines((prev: any) => {
          return [...prev, line];
        });
      }
    });
    // order results by detection_date
    // setResults(response.filter((item) => item.plate_number === selectedLicencePlate).sort((a, b) => (a.detection_date > b.detection_date ? 1 : -1)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const image = new Image();
  image.src = picture;

  const markers =
    results &&
    results.map((res, index) => {
      if (res && res.camera_lat && res.camera_long) {
        return {
          id: index,
          position: { lat: res.camera_lat, long: res.camera_long },
          name: res.camera_name,
          info: `${res.camera_name} - ${res.detection_time} - ${res.confidence * 100}% confidence`,
        };
      } else return { id: 0, position: { lat: 0, long: 0 }, name: '', info: '' };
    });

  const setAllLinesStart = () => {
    // change the line.color to yellow for all lines
    setLines((prev: any) => {
      return prev.map((line: any) => {
        return { ...line, color: 'yellow' };
      });
    });
  };

  const handlePlayerClick = () => {
    console.log('handlePlayerClick', { lines });
    if (isPlaying) {
      // Pause
      if (timeoutIds) clearTimeout(timeoutIds);
      setTimeoutIds(undefined);
      setIsPlaying(false);
      return;
    }

    if (!lines || lines.length === 0) return; // nothing to play

    // If finished previously or starting fresh, reset visuals
    if (currentLineIndexRef.current >= lines.length) {
      setAllLinesStart();
  setProgress(0);
  setHighlightedMarkerId(1);
  currentLineIndexRef.current = 0;
    }

    setIsPlaying(true);

    const step = () => {
      const idx = currentLineIndexRef.current;
      if (idx >= lines.length) {
        // Finished
        setIsPlaying(false);
        setTimeoutIds(undefined);
        setHighlightedMarkerId(-1);
        return;
      }

      // Highlight next marker (mirrors previous +2 logic)
      setHighlightedMarkerId(idx + 2);

      // Color current line green
      setLines((prev: any) => prev.map((line: any) => (line.id === idx ? { ...line, color: 'green' } : line)));

  const newIdx = idx + 1;
  currentLineIndexRef.current = newIdx;
  setProgress((newIdx / lines.length) * 100);

      if (newIdx >= lines.length) {
        // Completed all lines
        setIsPlaying(false);
        setTimeoutIds(undefined);
        return;
      }

      const tId = setTimeout(step, 1500);
      setTimeoutIds(tId);
    };

    // Immediate first step (no wait before showing first transition)
    step();
  };

  return (
    <div className='d-flex flex-column h-100vh justify-content-between'>
      <div className='d-flex flex-row h-100vh'>
        <div
          className='d-flex flex-column gap-3 col-md-4 border-end border-dark-50 border-2 p-3'
          style={{ overflowY: 'scroll', height: '80vh', position: 'relative' }}
        >
          <table className='table align-middle '>
            <thead className='thead-dark'>
              <tr className='fw-bolder fs-6 text-gray-800'>
                <th>Photo</th>
                <th>Conf.</th>
                <th>Date</th>
                <th>Camera</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody className='fw-bold text-gray-600'>
              {results.map((item, index) => (
                <tr key={index}>
                  <td
                    onClick={() => {
                      setSelectedItem(item);
                      toggleModal(0);
                    }}
                    style={{ cursor: 'pointer', width: '100px' }}
                  >
                    {/* <img src={`./${item.filename}`} alt='item' /> */}
                    <div
                      className='position-absolute cursor-pointer '
                      style={{
                        // make it the same height and width as the image
                        width: '100px',
                        height: `${100 * (9 / 16)}px`, // 16 : 9 is the aspect ratio of the image
                        top: '',
                        backgroundColor: 'transparent',
                        zIndex: '',
                        opacity: '0',
                        transition: 'opacity 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                        e.currentTarget.style.opacity = '0.8';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.opacity = '0';
                      }}
                    >
                      <div className='d-flex align-items-center justify-content-center' style={{ height: '100%' }}>
                        <button
                          type='button'
                          className='btn rounded btn-outline-dark border text-white'
                          style={{ opacity: '1', transition: 'opacity 0.4s' }}
                        >
                          View Image
                        </button>
                      </div>
                    </div>
                    {DEMO_ACCOUNTS.includes(userName) ? (
                      <CanvasComponent
                        // imageUrl={`/alerts-media/${tenantKey}/${new Date().getFullYear()}/${new Date().getMonth() + 1}/${personItem.filename}`}
                        imageUrl={picture}
                        actualHeight={image.naturalHeight}
                        actualWidth={image.naturalWidth}
                        bboxes={[{ x1: 200, y1: 100, x2: 550, y2: 500 }]}
                        canvasHeight={`${100 * (9 / 16)}px`}
                        canvasWidth={'100px'}
                      />
                    ) : (
                      <CanvasComponent
                        // imageUrl={`/alerts-media/${tenantKey}/${new Date().getFullYear()}/${new Date().getMonth() + 1}/${personItem.filename}`}
                        imageUrl={item.filename}
                        actualHeight={item.picture_height}
                        actualWidth={item.picture_width}
                        bboxes={[{ x1: 200, y1: 100, x2: 550, y2: 500 }]}
                        canvasHeight={`${100 * (9 / 16)}px`}
                        canvasWidth={'100px'}
                      />
                    )}
                  </td>
                  <td>{`${item.confidence * 100} %`}</td>
                  <td>{item.detection_time}</td>
                  <td>{item.camera_name}</td>
                  <td>{item.camera_location_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='d-flex flex-column gap-3 col-md-8 p-3 justify-content-center'>
          <div className='h-500px'>
            <LeafMap
              className={'h-500px bg-secondary mt-5'}
              allowMultipleMarkers={true}
              allowDelete={false}
              markers={markers}
              allowAdd={false}
              lines={lines}
              draggableMarkers={false}
              highlightMarkerId={highlightedMarkerId === -1 ? 1 : highlightedMarkerId}
            />
          </div>
        </div>
        {selectedItem && (
          <CommonModal
            closeButton={true}
            title={`Photo of ${selectedItem?.plate_number}`}
            show={show[0]}
            showModalCallback={() => toggleModal(0)}
            size='lg'
            closeButtonOptions={{}}
            confirmButton={false}
            confirmButtonOptions={{}}
          >
            <div className='d-flex flex-column justify-content-center align-items-center'>
              {DEMO_ACCOUNTS.includes(userName) ? (
                <AlertCanvasComponent
                  // imageUrl={`/alerts-media/${tenantKey}/${new Date().getFullYear()}/${new Date().getMonth() + 1}/${personItem.filename}`}
                  imageUrl={picture}
                  actualHeight={image.naturalHeight}
                  actualWidth={image.naturalWidth}
                  multiple_bboxes={[{ bboxes: [200, 100, 550, 500], detail_description: `${selectedItem?.plate_number}` }]}
                  canvasHeight={`${750 * (9 / 16)}px`}
                  canvasWidth={'750px'}
                  big={true}
                />
              ) : (
                <AlertCanvasComponent
                  // imageUrl={`/alerts-media/${tenantKey}/${new Date().getFullYear()}/${new Date().getMonth() + 1}/${personItem.filename}`}
                  imageUrl={selectedItem!.filename}
                  actualHeight={selectedItem!.picture_height}
                  actualWidth={selectedItem!.picture_width}
                  multiple_bboxes={[{ bboxes: [200, 100, 550, 500], detail_description: `${selectedItem?.plate_number}` }]}
                  canvasHeight={`${750 * (9 / 16)}px`}
                  canvasWidth={'750px'}
                  big={true}
                />
              )}
            </div>
          </CommonModal>
        )}
      </div>
      <div className='py-md-6 pb-6 d-flex align-items-center animated w-100 px-3 row-md-12'>
        <i
          className={`${isPlaying ? 'bi bi-pause-fill' : 'bi bi-play-fill'} cursor-pointer mb-1`}
          onClick={handlePlayerClick}
          style={{ fontSize: '3.5rem' }}
          title={isPlaying ? 'Pause' : currentLineIndexRef.current >= lines.length ? 'Replay' : 'Play'}
        ></i>
        <div
          className='progress ml-3 flex-grow-1 bg-secondary me-5'
          role='progressbar'
          aria-label='Animated striped example'
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div className='progress-bar progress-bar-striped progress-bar-animated bg-primary' style={{ width: `${progress}%` }}></div>
        </div>
      </div>
    </div>
  );
};

export default TrafficSearch;
